export enum MutationTypes {
    ADD_NOTIFICATION = 'notifications-module/add-notification',
    TOGGLE_FLUSH_NOTIFICATIONS = 'notifications-module/flush-notifications',
    REMOVE_NOTIFICATION = 'notifications-module/remove-notifications',
}
